import { useEffect, useState } from 'react';
import { getActiveSeason } from 'api/season';

/**
 * Fetches the club's active season name, for page subtitles on season-scoped
 * report and settings pages. Returns '' while loading or on failure so the
 * subtitle simply stays empty rather than disturbing the page.
 */
const useActiveSeasonName = (clubId) => {
  const [seasonName, setSeasonName] = useState('');

  useEffect(() => {
    if (!clubId) return;
    let cancelled = false;
    getActiveSeason(clubId)
      .then((res) => {
        if (!cancelled) setSeasonName(res.data?.name || '');
      })
      .catch((err) => {
        console.log('[useActiveSeasonName] Fetch active season error: ', err);
        if (!cancelled) setSeasonName('');
      });
    return () => {
      cancelled = true;
    };
  }, [clubId]);

  return seasonName;
};

export default useActiveSeasonName;
